// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2viOf","col":"styles_col__13MPf","fulfillmentStatus":"styles_fulfillmentStatus__1C0-R","emailCol":"styles_emailCol__KcykZ"};